export default __webpack_public_path__ + "static/DB_Feather-8dbf058cd3531e20eba3bba75f9d21f3.mp4";